import * as chrono from 'chrono-node';

export interface ParsedNaturalDate {
  value: number;
  hasTime: boolean;
}

/** Parse natural language date/time text (e.g. "today at midday", "next Friday"). */
export function parseNaturalDate(
  text: string,
  now: Date = new Date(),
): ParsedNaturalDate | undefined {
  const results = chrono.parse(text.trim(), now, { forwardDate: true });
  const first = results[0];
  if (!first) return undefined;
  return {
    value: first.start.date().getTime(),
    hasTime: first.start.isCertain('hour'),
  };
}
